import { AlertTriangle } from 'lucide-react';

const ErrorScreen = ({ error, onRetry, onHome }) => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4">
    <div className="card text-center">
      <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <AlertTriangle size={40} className="text-red-500" />
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mb-2">Verification Failed</h2>
      <p className="text-gray-600 mb-6">{error?.message || 'An unexpected error occurred'}</p>
      
      {error?.errorCode && (
        <p className="text-sm text-gray-500 mb-6">Error Code: {error.errorCode}</p>
      )}

      <div className="flex gap-4 justify-center">
        {onRetry && (
          <button onClick={onRetry} className="btn-primary">
            Try Again
          </button>
        )}
        {onHome && (
          <button onClick={onHome} className="btn-secondary">
            Go to Home
          </button>
        )}
      </div>
    </div>
  </div>
);

export default ErrorScreen;
